import { FunctionComponent, ReactNode } from "react";

export const Value: FunctionComponent<{ children: ReactNode }> = ({ children }) => <div style={{ fontSize: 60, fontWeight: "bold" }}>{children}</div>;
